import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store/store';
import i18n from './i18n';
import './VFG';
import '@mdi/font/css/materialdesignicons.css';

import 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.kz.js'; //US Phone Numbers Addon

import moment from 'moment';

import { TokenService } from './services/storage.service';
import { ApiService } from './services/api.service';

import './assets/css/roboto.css';

moment.locale('ru');
Vue.prototype.moment = moment;

// Set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API);
//ApiService.init('/api');

// If token exists set header
if (TokenService.getToken()) {
    ApiService.setHeader();
}

Vue.config.productionTip = false;

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm');
    }
});
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
